
export interface Page {
    pageSize?: number
    pageNum?: number
}
export interface Resource {
    // 没用数量
    uselessCount?: number
    // 浏览数量
    browseCount?: number
    // id
    id?: string
    // 文档标题
    title?: string
    // 有用数量
    usefulCount?: number
    categoryName: string
}

export interface Categorie {
    // 名字
    name?: string
    // 专辑id
    id?: string
    // 专题列表
    categories: Categorie[]
}

export class NextVO {
    // 资源标题
    public title?: string = undefined
    // 资源id
    public id?: string = undefined
}

export class PreVO {
    // 资源标题
    public title?: string = undefined
    // 资源id
    public id?: string = undefined
}

export class QuestionDetail {
    // 视频url
    public resUrl?: string = undefined
    // 前一个数据
    public preVO?: PreVO = new PreVO()
    // 资源类型
    public resType?: number = undefined
    // 分类id
    public resClassifyId?: number = undefined
    // 更新时间
    public updateTime?: string = undefined
    // 标题
    public title?: string = undefined
    // 资源附属类型 21:本地视频 22:网络视频
    public resSubType?: number = undefined
    // 正文
    public content?: string = undefined
    // 视频封面url
    public coverUrl?: string = undefined
    // 后一个数据
    public nextVO?: NextVO = new NextVO()
    // 创建时间
    public createTime?: string = undefined
    // 视频id
    public id?: number = undefined
    public useful?: number = undefined
}
export class SetUseful {
    // 视频url
    public id?: string = ''
    // 前一个数据
    public useful?: number = 0
}
export class FeedbackCreate {
    // 问题描述
    public msg?: string = undefined
    // 问题图片
    public urls?: string[] = undefined
    // 联系方式
    public contact?: string = undefined
}
export class QuestionPageParam {
    public pageSize: number = 8
    public pageNum: number = 1
    public title?: string = undefined
}
export class ICategorie {
    public parentId?: string = ''
    public id?: string = ''
    public categoryName?: string = ''
    public isChecked: boolean = false
    public resourceList?: Resource[] = []
    public categoryList: ICategorie[] = []
}
export interface IVideoType {
    /**
     * 视频封面url
     */
    coverUrl?: string;
    /**
     * 视频url
     */
    resUrl?: string;
    /**
     * 视频分类id
     */
    resClassifyId?: number;
    /**
     * 更新时间
     */
    updateTime?: string;
    /**
     * 视频id
     */
    id?: number;
    /**
     * 标题
     */
    title?: string;
    /**
     * 资源附属类型 21:本地视频 22:网络视频
     */
    resSubType?: number;
}
export interface IDocumentType {
    /**
     * 关系id
     */
    id?: number;
    /**
     * 资源标题
     */
    title?: string;
    /**
     * 栏目名
     */
    categoryName?: string;
    /**
     * 创建时间
     */
    updateTime?: string;
}
export interface IAllVideoType {
    /**
     * 视频封面url
     */
    coverUrl?: string;
    /**
     * 视频url
     */
    resUrl?: string;
    /**
     * 视频分类id
     */
    resClassifyId?: number;
    /**
     * 更新时间
     */
    updateTime?: string;
    /**
     * 视频id
     */
    id?: number;
    /**
     * 标题
     */
    title?: string;
    /**
     * 资源附属类型 21:本地视频 22:网络视频
     */
    resSubType?: number
}